import React, {useEffect} from 'react';
import {Accordion, AccordionDetails, AccordionSummary, makeStyles, useMediaQuery} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {getCatalog, selectActivePatientResults, setCabinetActiveTab} from "@cabinet-packages/redux";
import CabinetPatientAssaysHistory from "./CabinetPatientAssaysHistory";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
    scrollContainer: {
        padding: '0 10px',
        width: '100%',
        height: 'calc(100vh - 50px)', // Set a fixed height
        overflowY: 'scroll', // Enable scrolling

        '@media(min-width: 900px)': {
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }
    },
    assaysWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        rowGap: '8px',
        padding: '10px 0',
        width: '100%',
        margin: '0 auto',
        height: "max-content",

        '@media (max-width:1200px)': {
            justifyItems: 'center',
            gridTemplateColumns: '1fr 1fr',
            width: '100%',
        },
        '@media (max-width:600px)': {
            gridTemplateColumns: '1fr',
        },
    },
    headerLabel: {
        color: theme.palette.primary.dark,
    },
    extraLabel: {
        color: theme.palette.primary.main,
    },
    accordionSummaryRoot: {
        minHeight: '44px',
        padding: '0 12px',
        '&$accordionExpanded': {
            minHeight: '44px',
        },
    },
    accordionSummaryContent: {
        margin: '8px 0',
        '&$accordionExpanded': {
            margin: '8px 0',
        },
    },
    accordionExpanded: {},
    accordionDetails: {
        padding: '0 12px 8px',
    },
}))

const CabinetPatientAssaysHistoryWrapper = () => {
    const cl = useStyles()
    const {activePatientResults, listOfPatients} = useSelector(state => state.patients)
    const {catalog, takeId, complexId} = useSelector(state => state.assaysCatalog)
    const dispatch = useDispatch()
    const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));

    useEffect(() => {
        dispatch(setCabinetActiveTab("/patient-assays-history"));
    }, []);

    useEffect(() => {
        if (!activePatientResults && listOfPatients) {
            dispatch(selectActivePatientResults());
        }

    }, [dispatch, activePatientResults, listOfPatients]);

    useEffect(() => {
        if (!catalog && takeId && complexId) {
            dispatch(getCatalog())
        }
    }, [catalog, takeId, complexId]);

    return <div className={cl.scrollContainer}>
        <div style={{padding: '4px 0'}}>
            <Typography
                color={"textPrimary"}
                variant={mdUp ? "h4" : "h5"}
                className={cl.headerLabel}
            >
                Статистика досліджень
            </Typography>
            <Typography className={cl.extraLabel}>
                Тут відображається статистика усіх досліджень, які Ви робили більше
                двох разів
            </Typography>
        </div>
        <div className={cl.assaysWrapper}>
            {listOfPatients && listOfPatients?.map(patient => (
                <Accordion key={patient.id}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        classes={{
                            root: cl.accordionSummaryRoot,
                            content: cl.accordionSummaryContent,
                            expanded: cl.accordionExpanded,
                        }}
                    >
                        {patient && <Typography className={cl.extraLabel}>
                            Пацієнт: {`${patient.lastname} ${patient.firstname} ${patient.fathername}`}
                        </Typography>}
                    </AccordionSummary>
                    <AccordionDetails className={cl.accordionDetails} style={{height: "max-content"}}>
                        <CabinetPatientAssaysHistory activePatient={patient}/>
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    </div>
}

export default CabinetPatientAssaysHistoryWrapper;
